<template>
	<div class="contact_us u-flex-col u-col-center u-row-center">
		<img src="../assets/imgs/index1-2.png" class="about-bg" alt="">
		<img src="../assets/imgs/about1-1.png" class="about-top fadeInUp animated" alt="">
		<div class="about-title fadeInUp animated">
			{{$t('联系我们')}}
		</div>
		<div class="about-box">
			<div class="title fadeInUp animated">
				{{$t('联系我们')}}
			</div>
			<div class="about-row fadeInUp animated u-flex u-col-top">
				<img src="../assets/imgs/about1-2.png" alt="">
				<span>{{indexdata.phone}}</span>
			</div>
			<img src="../assets/imgs/about1-5.png" class="about-xian fadeInUp animated" alt="">
			<div class="about-row u-flex u-col-top fadeInUp animated">
				<img src="../assets/imgs/about1-3.png" alt="">
				<span>{{indexdata.mailbox}}</span>
			</div>
			<img src="../assets/imgs/about1-5.png" class="about-xian fadeInUp animated" alt="">
			<div class="about-row u-flex u-col-top fadeInUp animated">
				<img src="../assets/imgs/about1-4.png" alt="">
				<span v-if="$locale == 'zh'">{{indexdata.remarkWenan}}</span>
				<span v-if="$locale == 'en'">{{indexdata.remarkWenanEnglish}}</span>
				<span v-if="$locale == 'de'">{{indexdata.remarkWenanGerman}}</span>
			</div>
			<img src="../assets/imgs/about1-5.png" class="about-xian fadeInUp animated" alt="">
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				indexdata: {}
			}
		},
		mounted() {
			this.$parent.settitle(this.$t('联系我们'))
			this.getdata()
		},
		methods: {
			getdata() {
				this.$http.post('/api/Index/indexInfo').then(res => {
					this.indexdata = res.result
				})
			}
		}
	}
</script>

<style lang="scss">
.fadeInUp {
		-webkit-animation-name: fadeInUp;
    animation-name: fadeInUp;
		visibility: visible;
	}
	.animated {
    -webkit-animation-duration: 1.5s;
    animation-duration: 1.5s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
	}
	@keyframes fadeInUp {
		0% {
			opacity: 0;
			-webkit-transform: translate3d(0,100%,0);
			transform: translate3d(0,100%,0);
		}
		100% {
			opacity: 1;
			-webkit-transform: none;
			transform: none;
		}
	}
</style>
